import { combineReducers } from 'redux';
import BookingReducer from './BookingReducer';
import LoadingReducer from './LoadingReducer';

const rootReducer = combineReducers({
  booking: BookingReducer,
  loading: LoadingReducer
});

export default rootReducer;
